/**
 * Update an existing category
 * @param {string} API_BASE - Base API URL
 * @param {string} token - JWT token
 * @param {number|string} id - Category ID
 * @param {Object} payload - Category payload { name: string }
 * @returns {Promise<Object>} Updated category object
 */
async function updateCategory(API_BASE, token, id, payload) {
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE}/categories/${id}`, {
        method: "PUT",
        headers,
        body: JSON.stringify(payload)
    });

    if (!response.ok) {
        throw new Error("Erreur mise à jour de la catégorie: " + (await response.text()));
    }

    return await response.json();
}

export default updateCategory;
